import { t } from 'i18next'
import React, { useEffect, useRef, useState } from 'react'
import Cookies from 'universal-cookie'
import LoadingScreen from '../../../components/custom/LoadingScreen'
import MarketingService from '../../../services/marketingService'
import { KEYS } from '../../../utils/storage'
import CouponsTable from './coupons-table'
import DiscountsTable from './discounts-table'
import PromotionsTable from './promotions-table'

export const promotionsText = (text) => t(`marketing.promotions.view.${text}`)

const Promotions = () => {
	const _curPromotion = useRef(null)
	const _curDiscount = useRef(null)
	const _curCoupon = useRef(null)
	const cookies = new Cookies()

	const venueType = cookies.get(KEYS.VENUE_TYPE)
	const [promoData, setPromoData] = useState([])
	const [discountData, setDiscountData] = useState([])
	const [couponData, setCouponData] = useState([])
	const [loaded, setLoaded] = useState(false)
	const [callEnd, setCallEnd] = useState({ promo: false, discount: false })

	useEffect(() => {
		refreshData()
	}, [])

	useEffect(() => {
		if (callEnd.promo && (callEnd.discount || callEnd.coupon)) {
			setLoaded(true)
		}
	}, [callEnd])

	const refreshData = () => {
		MarketingService.GetPromotions()
			.then((res) => {
				setCallEnd((v) => ({ ...v, promo: true }))
				setPromoData(res.data)
			})
			.catch((err) => {
				setCallEnd((v) => ({ ...v, promo: true }))
			})

		if (
			venueType === 'restaurant' ||
			venueType === 'sport_essentials' ||
			venueType === 'pharmacy' ||
			venueType === 'online_shop' ||
			venueType === 'fashion_threads' ||
			venueType === 'home_decor'
		) {
			MarketingService.GetCoupons()
				.then((res) => {
					setCallEnd((v) => ({ ...v, coupon: true }))
					setCouponData(res.data)
				})
				.catch((err) => {
					setCallEnd((v) => ({ ...v, coupon: true }))
				})
		}

		MarketingService.GetDiscounts()
			.then((res) => {
				setCallEnd((v) => ({ ...v, discount: true }))
				setDiscountData(res.data)
			})
			.catch((err) => {
				setCallEnd((v) => ({ ...v, discount: true }))
			})
	}

	const isRetail = () => {
		return (
			venueType === 'sport_essentials' ||
			venueType === 'pharmacy' ||
			venueType === 'home_decor' ||
			venueType === 'online_shop' ||
			venueType === 'fashion_threads'
		)
	}

	return (
		<div>
			<div className="flex flex-col h-full">
				{loaded ? (
					<div className="flex flex-col p-024  overflow-auto">
						<PromotionsTable
							{...{
								_curPromotion,
								couponData,
								refreshData,
								venueType,
								discountData,
								promoData,
							}}
						/>

						{(venueType === 'restaurant' ||
							venueType === 'pharmacy' ||
							venueType === 'sport_essentials' ||
							venueType === 'fashion_threads' ||
							venueType === 'home_decor' || venueType === 'online_shop') && (
							<CouponsTable
								{...{ _curCoupon, isRetail, setCallEnd, venueType }}
							/>
						)}

						<DiscountsTable
							{...{
								_curDiscount,
								isRetail,
								refreshData,
								venueType,
								discountData,
							}}
						/>
					</div>
				) : (
					<LoadingScreen />
				)}
			</div>
		</div>
	)
}

export default Promotions
